<template>
  <div class="helpTools">
    <div class="title">
      <div class="blue-line"></div>
      自助工具
    </div>
    <div class="container">
      <div
        class="container-item"
        v-for="(item, index) in list" 
        :key="index"
        @click="item.click()"
      >
        <img :src="item.img" alt="">
        <div>{{ item.title }}</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: () => [],
    },
  },
}
</script>

<style lang="scss">
.helpTools {
  // width: calc(100% - 30px);
  width: calc(100% - 0px);
  background: #ffffff;
  margin: 10px 0;
  border-radius: 5px;
  padding: 0 15px;
  .title {
    padding: 10px 0;
    font-size: 15px;
    font-weight: bold;
    .blue-line {
      margin-right: 5px;
      vertical-align: baseline;
      display: inline-block;
      width: 3px;
      height: 12px;
      border-radius: 10px;
      background-color: #3296FA;
    }
  }
  .container {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    flex-wrap: wrap;
    padding: 0 0 15px 10px;
    &-item {
      margin: 10px 15px 0 15px;
      img {
        width: 45px;
        height: 45px;
        border-radius: 50%;
      }
      div {
        margin-top: 6px;
        font-size: 12px;
      }
    }
  }
}
</style>
